import { motion, useScroll, useTransform } from 'framer-motion';

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const bg = 'linear-gradient(90deg, #1E6FD9, #E8A020, #F5B840)';

  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-0.5 z-[9997] origin-left"
      style={{
        background: bg,
        scaleX: scrollYProgress,
        transformOrigin: '0% 50%',
      }}
    />
  );
}
